var r,e;function n(){return e?r:(e=1,r=function(){throw new Error("Readable.from is not available in the browser")})}export{n as __require};
